var _path, _circle, _circle2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconCart = function SvgIconCart(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 4L5.98617 7.88C6.04112 7.95954 6.08217 8.048 6.10799 8.14263L7.5526 13.3787C7.60208 13.5578 7.70651 13.7152 7.8501 13.8273C7.99368 13.9394 8.1686 14 8.3484 14H17.8543C18.035 14 18.2107 13.9387 18.3547 13.8256C18.4986 13.7124 18.6028 13.5535 18.6514 13.3733L19.9821 8.42857M6.20663 8.28594H8.96544M17.2412 8.28594H20",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 9.5,
    cy: 18.5,
    r: 2,
    stroke: "black",
    strokeWidth: 1.75
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 16.5,
    cy: 18.5,
    r: 2,
    stroke: "black",
    strokeWidth: 1.75
  })));
};
export default SvgIconCart;